import React, { ReactNode } from 'react';
import ReactDom from 'react-dom';
// import './Modal.scss';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  header?: ReactNode | string;
  footer?: ReactNode | string;
  closeIcon?: ReactNode; // Optional closeIcon prop
  width?: string; // Optional width prop
  modalId?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, modalId, header, footer, closeIcon, width }) => {
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const InnerBox = () => (
    <div className="FounditUI__modal-content" style={{ width: width || 'auto' }}>
      {header && <div className="FounditUI__modal-header">{header}</div>}
      <div className="FounditUI__modal-body">{children}</div>
      {footer && <div className="FounditUI__modal-footer">{footer}</div>}
    </div>
  );

  if(!isOpen) {
    return null;
  }

  return ReactDom.createPortal(
    <>
      {isOpen && (
        <div id={modalId} className="FounditUI__modal-backdrop" onClick={handleBackdropClick}>
          <div className="FounditUI__modal-wrapper">
            {closeIcon && (
              <div className="FounditUI__close-button-icon" onClick={onClose}>
                {closeIcon}
              </div>
            )}
            <InnerBox />
          </div>
        </div>
      )}
    </>,
    document.body
  );
};

export default Modal;


// eg usage:
// <div>
//     <button onClick={openModal}>Open Modal</button>
//     <Modal isOpen={isModalOpen} onClose={closeModal} header={header} footer={footer} closeIcon={<ModalCloseIcon />}>
//         {/* Your modal content goes here */}
//         {test}
//     </Modal>
// </div>